import type { ReactElement } from "react";

import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";
import { ExportVariantsDropdownItem } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import * as siRoutes from "app/pages/sales-intelligence/constants/routes";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { isContactNameHidden } from "app/pages/sales-intelligence/sub-modules/contacts-search/utils/isContactNameHidden";
import { proNavigator } from "single-spa/react-app/ProNavigator";

interface IProps {
    domain: string;
    attendee?: string;
    onClick?: VoidFunction;
}

const AiMeetingAgentDropdownItem = ({ domain, attendee, onClick }: IProps): ReactElement => {
    const isDisabled = !salesSettingsHelper.isAiMeetingAgentEnabled || isContactNameHidden(attendee);

    const prepareForMeetingLink = proNavigator.href(siRoutes.AI_AGENT_MEETING, { domain, attendee });

    const dropdownItem = (
        <ExportVariantsDropdownItem
            iconName="ai-calendar"
            isDisabled={isDisabled}
            iconColor={colorsPalettes.carbon[200]}
            text={translate("si.company-analysis.company.ai-agent.meeting.button")}
            variant="meeting"
            onClick={onClick}
        />
    );

    if (!isDisabled) {
        return (
            <a
                href={prepareForMeetingLink}
                target="_blank"
            >
                {dropdownItem}
            </a>
        );
    }

    return dropdownItem;
};

export default AiMeetingAgentDropdownItem;
